import axios from './http';
import { CodeGroupDto, UpsertCodeGroupDto } from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/code-groups`;

export const getAllCodeGroups = (withDeleted: boolean, source: CancelTokenSource): Promise<Array<CodeGroupDto>> => {
  return axios
      .get(`${apiUri}`, {params: {withDeleted: withDeleted}, cancelToken: source.token})
      .then(response => response.data);
};

export const searchCodeGroups = (codeGroupsearchTerm: String,
                            source: CancelTokenSource): Promise<Array<CodeGroupDto>> => {
  return axios
      .get(`${apiUri}`, {params: {query: codeGroupsearchTerm}, cancelToken: source.token})
      .then(response => response.data)
};

export const findCodeGroupById = (id: number, source: CancelTokenSource): Promise<UpsertCodeGroupDto> => {
  return axios
      .get(`${apiUri}/${id}`,{cancelToken: source.token})
      .then(response => response.data)
};

export const deleteCodeGroup = (id: number, source: CancelTokenSource): Promise<CodeGroupDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addCodeGroup = (upsertCodeGroupDto: Partial<UpsertCodeGroupDto>, source: CancelTokenSource): Promise<CodeGroupDto> => {
  return axios
      .post(apiUri, upsertCodeGroupDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editCodeGroup = (id: number, upsertCodeGroupDto: Partial<UpsertCodeGroupDto>, source: CancelTokenSource): Promise<CodeGroupDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertCodeGroupDto, {cancelToken: source.token})
      .then(response => response.data);
};
